import { render } from "./520x.vue?vue&type=template&id=7d29f935"
import script from "./520x.vue?vue&type=script&lang=js"
export * from "./520x.vue?vue&type=script&lang=js"

import "./520x.vue?vue&type=style&index=0&id=7d29f935&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__